// Native disclosure menu: keyboard support and close after selecting a destination.
document.addEventListener('click', (event) => {
  const menu = document.querySelector('.pv-mobile-menu[open]');
  if (menu && (!menu.contains(event.target) || event.target.closest('a'))) menu.open = false;
});
document.addEventListener('keydown', (event) => {
  const menu = document.querySelector('.pv-mobile-menu[open]');
  if (event.key === 'Escape' && menu) {
    menu.open = false;
    menu.querySelector('summary').focus();
  }
});
document.addEventListener('input', (event) => {
  if (!event.target.matches('[data-pv-brand-search]')) return;
  const directory = event.target.closest('.pv-brand-directory');
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const query = normalize(event.target.value.trim());
  let count = 0;
  directory.querySelectorAll('[data-pv-brand]').forEach(link => {
    link.hidden = !normalize(link.dataset.pvBrand).includes(query);
    if (!link.hidden) count++;
  });
  directory.querySelector('.pv-no-brands').hidden = count !== 0;
});
const primevoEnquiry = new URLSearchParams(window.location.search);
const primevoBrand = (primevoEnquiry.get('marque') || '').slice(0, 120);
const primevoReference = (primevoEnquiry.get('reference') || '').slice(0, 120);
if (primevoBrand || primevoReference) {
  const message = document.querySelector('textarea[name="contact[body]"]');
  const strings = document.getElementById('primevo-contact-i18n');
  if (message && strings && !message.value.trim()) {
    try {
      const copy = JSON.parse(strings.textContent);
      message.value = copy.prefill.replace('__BRAND__', () => primevoBrand).replace('__REFERENCE__', () => primevoReference);
    } catch { /* The contact form remains usable without prefill. */ }
  }
}

// Progressive enhancement: content stays visible if animation APIs are unavailable.
// No scroll handler, perpetual motion, or hidden elements waiting for JavaScript.
(() => {
  if (document.body.dataset.pvMotion === 'false' || !window.matchMedia || !window.IntersectionObserver || !Element.prototype.animate || window.Shopify?.designMode) return;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observed = new WeakSet();
  const active = new Map();
  const selector = '.pv-section-heading, .pv-universe, .pv-brand-featured > a, .pv-catalogue-grid > article, .pv-steps > li, .pv-invitation > h2, .pv-page-cards > article, .pv-page-heading';
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      if (preference.matches || document.hidden || entry.target.contains(document.activeElement)) continue;
      try {
        const animation = entry.target.animate([
          { opacity: 0.4, transform: 'translateY(18px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 680, easing: 'cubic-bezier(.2,.7,.3,1)' });
        active.set(entry.target, animation);
        animation.onfinish = animation.oncancel = () => active.delete(entry.target);
      } catch { /* Optional enhancement must never break navigation. */ }
    }
  }, { threshold: 0.12, rootMargin: '0px 0px -20px 0px' });
  const cancel = () => {
    active.forEach(animation => animation.cancel());
    active.clear();
  };
  const scan = root => {
    root.querySelectorAll(selector).forEach(element => {
      if (observed.has(element)) return;
      observed.add(element);
      if (!preference.matches) observer.observe(element);
    });
  };
  scan(document);
  preference.addEventListener?.('change', () => {
    if (preference.matches) { cancel(); observer.disconnect(); }
  });
  document.addEventListener('visibilitychange', () => { if (document.hidden) cancel(); });
  document.addEventListener('focusin', event => {
    active.forEach((animation, element) => { if (element.contains(event.target)) animation.cancel(); });
  });
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selector).forEach(element => { observer.unobserve(element); active.get(element)?.cancel(); });
  });
})();

